export default {
  bookingStatuses: [],
};
